var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.processing),expression:"!processing"}],attrs:{"id":"paypal-button"}}),_vm._v(" "),(_vm.processing)?_c('div',[_c('i',{staticClass:"fa fa-refresh fa-spin"}),_vm._v(" Processing PayPal transaction.\n    ")]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f36a196","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/Components/Checkout/Payments/PaypalGateway.vue
// module id = Whon
// module chunks = 0